module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1077.99765a34.png";